import { get, post } from "@insite/client-framework/Services/ApiService";
import { WORCarrier } from "@tKgpco/Store/Data/WOR/WORCarrierState";

const cacheKey = "worData";
const infoData = "worDeliveyInfoData";

export const setInLocalStorage = (worData: Record<string, any>) => {
    window.localStorage.setItem(cacheKey, JSON.stringify(worData));
};

export const setDeliveryContactInfoInLocalStorage = (info: Record<string, any>) => {
    window.localStorage.setItem(infoData, JSON.stringify(info));
};

export function getWORData(): Record<string, any> {
    return JSON.parse(window.localStorage.getItem(cacheKey) || "{}") as Record<string, any>;
}
export function getWORDeliveryInfoData(): Record<string, any> {
    return JSON.parse(window.localStorage.getItem(infoData) || "{}") as Record<string, any>;
}

export const getCarriersAndServices = async () => {
    const worData = getWORData();
    const parameter: any[] = [];

    worData?.items?.forEach((element: any) => {
        if (element.releaseMaterial) {
            parameter.push({
                ProductId: element.productNumber,
                QTY: Number(element.releaseQty),
            });
        }
    });

    const response = await post<WORCarrier[]>("/api/v2/WOR/GetCarriersAndServices", parameter);
    return response;
    // return [
    //     {
    //         carrierName: "UPS",
    //         shipVias: [
    //             { serviceName: "UPS Default", serviceCode: "KGPTM-Stan", isDefault: true },
    //             { serviceName: "UPS 2DAM", serviceCode: "UPS-2DAM", isDefault: false },
    //             { serviceName: "UPS GROUND", serviceCode: "UPS-GROU", isDefault: false },
    //         ],
    //     },
    //     {
    //         carrierName: "FEDEX",
    //         shipVias: [{ serviceName: "FEDEX GROUND", serviceCode: "FEDEX-GRND", isDefault: false }],
    //     },
    // ];
};
